import { Layout } from "@/components/Layout";

export default function TermsOfUse() {
  return (
    <Layout>
      <div className="container-main py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-serif font-bold text-foreground mb-8">Términos de Uso</h1>
          
          <div className="prose prose-stone max-w-none">
            <p className="text-stone-600 mb-6">
              Última actualización: {new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">1. Aceptación de los Términos</h2>
              <p className="text-stone-600 leading-relaxed">
                Al acceder y utilizar la plataforma Apoyum ("Servicio"), usted acepta estar sujeto a estos Términos de Uso. 
                Si no está de acuerdo con alguna parte de estos términos, no podrá acceder al Servicio.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">2. Descripción del Servicio</h2>
              <p className="text-stone-600 leading-relaxed mb-4">
                Apoyum es una plataforma que conecta a usuarios con "listeners" (escuchadores) para sesiones de 
                acompañamiento emocional y bienestar. Es importante entender que:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li>Apoyum <strong>NO es un servicio médico</strong> ni de salud mental profesional.</li>
                <li>Los listeners <strong>NO son terapeutas, psicólogos ni profesionales de salud mental licenciados</strong>.</li>
                <li>El servicio es únicamente de <strong>acompañamiento y escucha activa</strong>.</li>
                <li>Este servicio <strong>NO sustituye</strong> la atención médica o psicológica profesional.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">3. Elegibilidad</h2>
              <p className="text-stone-600 leading-relaxed">
                Para usar Apoyum, debe tener al menos 18 años de edad. Al usar el Servicio, declara y garantiza 
                que tiene la capacidad legal para celebrar un contrato vinculante.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">4. Cuentas de Usuario</h2>
              <p className="text-stone-600 leading-relaxed mb-4">
                Al crear una cuenta, usted acepta:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li>Proporcionar información precisa, actual y completa.</li>
                <li>Mantener la seguridad de su contraseña.</li>
                <li>Aceptar la responsabilidad de todas las actividades bajo su cuenta.</li>
                <li>Notificarnos inmediatamente sobre cualquier uso no autorizado.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">5. Pagos y Reembolsos</h2>
              <p className="text-stone-600 leading-relaxed mb-4">
                Los pagos se procesan a través de Stripe. Al realizar un pago:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li>Acepta los términos de servicio de Stripe.</li>
                <li>Las sesiones pagadas son para la fecha y hora acordadas.</li>
                <li>Las cancelaciones con menos de 24 horas de anticipación pueden no ser elegibles para reembolso.</li>
                <li>Los reembolsos se procesarán dentro de 5-10 días hábiles.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">6. Conducta del Usuario</h2>
              <p className="text-stone-600 leading-relaxed mb-4">
                Al usar Apoyum, usted acepta NO:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li>Usar el servicio para cualquier propósito ilegal.</li>
                <li>Acosar, amenazar o intimidar a otros usuarios o listeners.</li>
                <li>Compartir contenido inapropiado, ofensivo o ilegal.</li>
                <li>Intentar acceder a cuentas de otros usuarios.</li>
                <li>Usar el servicio si está en crisis de salud mental (busque ayuda profesional).</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">7. Situaciones de Crisis</h2>
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p className="text-red-800 leading-relaxed">
                  <strong>IMPORTANTE:</strong> Si usted o alguien que conoce está en crisis o tiene pensamientos suicidas, 
                  por favor contacte a servicios de emergencia locales o:
                </p>
                <ul className="list-disc pl-6 text-red-800 mt-2 space-y-1">
                  <li>En USA: Llame al 988 (Suicide & Crisis Lifeline)</li>
                  <li>En México: Llame a SAPTEL al 55 5259-8121</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">8. Limitación de Responsabilidad</h2>
              <p className="text-stone-600 leading-relaxed">
                Apoyum y sus listeners no serán responsables por daños directos, indirectos, incidentales o 
                consecuentes que resulten del uso del Servicio. El uso del Servicio es bajo su propio riesgo.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">9. Modificaciones</h2>
              <p className="text-stone-600 leading-relaxed">
                Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios 
                entrarán en vigor inmediatamente después de su publicación en el sitio.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">10. Contacto</h2>
              <p className="text-stone-600 leading-relaxed">
                Si tiene preguntas sobre estos Términos de Uso, puede contactarnos en:{" "}
                <a href="mailto:legal@apoyum.com" className="text-primary hover:underline">legal@apoyum.com</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
